import React, { createContext, useState, useCallback, useMemo, useContext } from 'react';
import { customerService } from '../services/CustomerService';

export const CustomerContext = createContext();

export const CustomerProvider = props => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [customersList, setCustomersList] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const [total, setTotal] = useState(0);
    const [sortState, setSortState] = useState([{ fieldName: 'CompanyName', dir: 'asc' }]);
    const [err, setErr] = useState(null);

    const queryCustomers = useCallback(async () => {
        const res = await customerService.getCustomers(pageSize, pageIndex, sortState[0]?.fieldName, sortState[0]?.dir);

        setCustomers(res.data);
        setTotal(res.total);
    }, [pageIndex, pageSize, sortState]);

    const getCustomerById = useCallback(id => {
        return customerService.getCustomerById(id);
    }, []);

    const createCustomer = useCallback(
        (name, firstName, lastName, addressOne, addressTwo, state, city, zipcode, email, phoneNumber, distributorId) => {
            return customerService.postCustomer(
                name,
                firstName,
                lastName,
                email,
                phoneNumber,
                addressOne,
                addressTwo,
                state,
                city,
                zipcode,
                distributorId
            );
        },
        []
    );

    const editCustomer = useCallback(
        (id, name, firstName, lastName, addressOne, addressTwo, state, city, zipcode, email, phoneNumber, distributorId, groupId) => {
            return customerService.editCustomer(
                id,
                name,
                firstName,
                lastName,
                email,
                phoneNumber,
                addressOne,
                addressTwo,
                state,
                city,
                zipcode,
                distributorId,
                groupId
            );
        },
        []
    );

    const deleteCustomer = useCallback(id => {
        return customerService.deleteCustomer(id);
    }, []);

    const getAllCustomers = useCallback(() => {
        return customerService
            .getAllCustomers('CompanyName', 'desc')
            .then(res => {
                setCustomersList(res.data);
                setTotal(res.total);
            })
            .catch(err => setErr(err));
    }, []);

    const values = useMemo(
        () => ({
            customers,
            customersList,
            total,
            pageSize,
            pageIndex,
            sortState,
            setTotal,
            setPageSize,
            setPageIndex,
            setSortState,
            queryCustomers,
            createCustomer,
            getCustomerById,
            editCustomer,
            deleteCustomer,
            getAllCustomers,
            err,
            selectedCustomer,
            setSelectedCustomer
        }),
        [customers, customersList, pageSize, pageIndex, sortState, total, err, queryCustomers, createCustomer, getCustomerById, editCustomer, deleteCustomer, getAllCustomers, selectedCustomer, setSelectedCustomer]
    );

    return <CustomerContext.Provider value={values}>{props.children}</CustomerContext.Provider>;
};

export const useCustomers = () => {
    const context = useContext(CustomerContext);

    if (context === undefined) {
        throw new Error('useCustomers must be used within a CustomerProvider component.');
    }

    return context;
};
